import { useSuspenseQuery } from '@tanstack/react-query';

import { getProjectValidationHistoryOptions } from '@/module/Author/Project/Validation/model/ProjectValidationModel';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

interface ProjectValidationHistoryProps {
  projectId: Id;
}

export function ProjectValidationHistory({ projectId }: ProjectValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getProjectValidationHistoryOptions(projectId));

  return <ValidationHistoryContent history={history} />;
}
